import { createSlice } from '@reduxjs/toolkit';

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    menuData: [],
  },
  reducers: {
    setMenu: (state, action) => {
      state.menuData = action.payload;
    },
    clearMenu: (state) => {
      state.menuData = [];
    },
  },
});

export const { setMenu, clearMenu } = menuSlice.actions;
export default menuSlice.reducer;
